import React from 'react'

import { Row, Col, Portlet } from '_zari/core'

import IdGrupoContableCompraFormGroup from './formGroups/idGrupoContableCompra'
import IdGrupoContableVentaFormGroup from './formGroups/idGrupoContableVenta'
import IdGrupoContableExistenciasFormGroup from './formGroups/idGrupoContableExistencias'
import IdGrupoContableInventarioFormGroup from './formGroups/idGrupoContableInventario'
import IdGrupoContableVariacionFormGroup from './formGroups/idGrupoContableVariacion'
import IdGrupoContableGastoFormGroup from './formGroups/idGrupoContableGasto'

const GruposContablesSection = ({
  values,
  setValues,
  errors,
  touched,
  isSubmitting,
  gruposContablesVentas,
  gruposContablesCompras,
  gruposContablesExistencias,
  gruposContablesInventarios,
  gruposContablesVariacion,
  gruposContablesGasto,
  actualizarGruposContablesCompras,
  actualizarGruposContablesVentas,
  actualizarGruposContablesExistencias,
  actualizarGruposContablesInventarios,
  actualizarGruposContablesVariacion,
  actualizarGruposContablesGasto
}) => {
  return (
    <>
      <Portlet>
        <Portlet.Body noPadding>
          <Row>
            <Col md={6}>
              <IdGrupoContableCompraFormGroup
                values={values}
                setValues={setValues}
                iError={errors.cuentaContableCompra}
                iTouched={touched.cuentaContableCompra}
                fIsSubmitting={isSubmitting}
                gruposContablesCompras={gruposContablesCompras}
                actualizarGruposContablesCompras={actualizarGruposContablesCompras}
              />
              <IdGrupoContableVentaFormGroup
                values={values}
                setValues={setValues}
                iError={errors.cuentaContableVenta}
                iTouched={touched.cuentaContableVenta}
                fIsSubmitting={isSubmitting}
                gruposContablesVentas={gruposContablesVentas}
                actualizarGruposContablesVentas={actualizarGruposContablesVentas}
              />
              <IdGrupoContableVariacionFormGroup
                values={values}
                setValues={setValues}
                iError={errors.cuentaContableVariacion}
                iTouched={touched.cuentaContableVariacion}
                fIsSubmitting={isSubmitting}
                gruposContablesVariacion={gruposContablesVariacion || []}
                actualizarGruposContablesVariacion={actualizarGruposContablesVariacion}
              />
            </Col>
            <Col md={6}>
              <IdGrupoContableExistenciasFormGroup
                values={values}
                setValues={setValues}
                iError={errors.cuentaContableExistencias}
                iTouched={touched.cuentaContableExistencias}
                fIsSubmitting={isSubmitting}
                gruposContablesExistencias={gruposContablesExistencias}
                actualizarGruposContablesExistencias={actualizarGruposContablesExistencias}
              />
              <IdGrupoContableInventarioFormGroup
                values={values}
                setValues={setValues}
                iError={errors.cuentaContableInventario}
                iTouched={touched.cuentaContableInventario}
                fIsSubmitting={isSubmitting}
                gruposContablesInventarios={gruposContablesInventarios}
                actualizarGruposContablesInventarios={actualizarGruposContablesInventarios}
              />
              <IdGrupoContableGastoFormGroup
                values={values}
                setValues={setValues}
                iError={errors.cuentaContableGasto}
                iTouched={touched.cuentaContableGasto}
                fIsSubmitting={isSubmitting}
                gruposContablesGasto={gruposContablesGasto || []}
                actualizarGruposContablesGasto={actualizarGruposContablesGasto}
              />
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(GruposContablesSection)
